//App action types
export const INIT_START = "INIT_START";
export const INIT_SUCCESS = "INIT_SUCCESS";
export const INIT_FAIL = "INIT_FAIL";
export const APP_ERROR = "APP_ERROR";
export const APP_ADD_MESSAGE = "APP_ADD_MESSAGE";
export const APP_REMOVE_DIALOG = "APP_REMOVE_DIALOG";
export const APP_MODULE_SUCCESS = "APP_MODULE_SUCCESS";
export const APP_MODULE_ERROR = "APP_MODULE_ERROR";
export const APP_MODULES_INIT = "APP_MODULES_INIT";
export const APP_MODULES_LOAD_SUCCESS = "APP_MODULES_LOAD_SUCCESS";

export const APP_MODULE_LIMIT_ERROR = "APP_MODULE_LIMIT_ERROR";
export const APP_LIMIT_CLIP = "APP_LIMIT_CLIP";
export const APP_LIMIT_USER = "APP_LIMIT_USER";
export const APP_LIMIT_ROOM = "APP_LIMIT_ROOM";
export const APP_GET_KEYS = "APP_GET_KEYS";
export const APP_ADD_KEY = "APP_ADD_KEY";
export const APP_REMOVE_KEY = "APP_REMOVE_KEY";
export const APP_GET_PRODUCTS = "APP_GET_PRODUCTS";
export const APP_ENABLE_PRODUCT = "APP_ENABLE_PRODUCT";
export const APP_DISABLE_PRODUCT = "APP_DISABLE_PRODUCT";
export const APP_GET_VERSION_SUCCESS = "APP_GET_VERSION_SUCCESS";


//CropImage
export const CROPIMAGE_UPDATE_CROPOBJECTS = "CROPIMAGE_UPDATE_CROPOBJECTS";
export const CROPIMAGE_UPDATE_CROPOBJECTS_START = "CROPIMAGE_UPDATE_CROPOBJECTS_START";
export const CROPIMAGE_UPDATE_CROPOBJECTS_SUCCESS = "CROPIMAGE_UPDATE_CROPOBJECTS_SUCCESS";
export const CROPIMAGE_UPDATE_CROPOBJECTS_FAIL = "CROPIMAGE_UPDATE_CROPOBJECTS_FAIL";
export const CROPIMAGE_IMPORT_CROPOBJECTS_START = "CROPIMAGE_IMPORT_CROPOBJECTS_START";
export const CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS = "CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS";
export const CROPIMAGE_IMPORT_CROPOBJECTS_FAIL = "CROPIMAGE_IMPORT_CROPOBJECTS_FAIL";
export const CROPIMAGE_SET_LOADING = "CROPIMAGE_SET_LOADING";
export const CROPIMAGE_SET_INIT_CROPOBJECTS = "CROPIMAGE_SET_INIT_CROPOBJECTS";

//Mailing
export const MAILINGTOOL_UPDATE_MAILINGOBJECTS_FAIL = "MAILINGTOOL_UPDATE_MAILINGOBJECTS_FAIL";
export const MAILINGTOOL_UPDATE_MAILINGOBJECTS_SUCCESS = "MAILINGTOOL_UPDATE_MAILINGOBJECTS_SUCCESS";
export const MAILINGTOOL_UPDATE_MAILINGOBJECTS_START = "MAILINGTOOL_UPDATE_MAILINGOBJECTS_START";
export const MAILINGTOOL_SEND_MAILINGOBJECTS = "MAILINGTOOL_SEND_MAILINGOBJECTS";
export const MAILINGTOOL_SEND_MAILINGOBJECTS_FAIL = "MAILINGTOOL_SEND_MAILINGOBJECTS_FAIL";
export const MAILINGTOOL_SET_LOADING = "MAILINGTOOL_SET_LOADING";
export const MAILINGTOOL_SET_INIT_MAILINGOBJECTS = "MAILINGTOOL_SET_INIT_MAILINGOBJECTS";

//Share
export const SHARE_UPDATE_SHAREOBJECTS_SUCCESS = "SHARE_UPDATE_SHAREOBJECTS_SUCCESS";
export const SHARE_UPDATE_SHAREOBJECTS_START = "SHARE_UPDATE_SHAREOBJECTS_START";
export const SHARE_SET_LOADING = "SHARE_SET_LOADING";
export const SHARE_SET_INIT_SHAREOBJECTS = "SHARE_SET_INIT_SHAREOBJECTS";

//Ecommerce
export const ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_SUCCESS = "ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_SUCCESS";
export const ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_START = "ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_START";
export const ECOMMERCE_SET_LOADING = "ECOMMERCE_SET_LOADING";
export const ECOMMERCE_SET_INIT_ECOMMERCEOBJECTS = "ECOMMERCE_SET_INIT_ECOMMERCEOBJECTS";

//Sort
export const SORT_UPDATE_SORTOBJECTS = "SORT_UPDATE_SORTOBJECTS";
export const SORT_SET_INITIAL_STATE = "SORT_SET_INITIAL_STATE";
export const SORT_UPDATE_SORTOBJECTS_SUCCESS = "SORT_UPDATE_SORTOBJECTS_SUCCESS";

//Sort
export const FLEX_UPDATE_FLEXOBJECTS = "FLEX_UPDATE_FLEXOBJECTS";
export const FLEX_SET_INITIAL_STATE = "FLEX_SET_INITIAL_STATE";
export const FLEX_UPDATE_FLEXOBJECTS_SUCCESS = "FLEX_UPDATE_FLEXOBJECTS_SUCCESS";
export const FLEX_SAVE_USERSEARCHDATA_SUCCESS = "FLEX_SAVE_USERSEARCHDATA_SUCCESS";

//Faces
export const FACES_UPDATE_OBJECTS_SUCCESS = "FACES_UPDATE_OBJECTS_SUCCESS";
export const FACE_UPDATE_FACEOBJECTS_SUCCESS = "FACE_UPDATE_FACEOBJECTS_SUCCESS";
export const FACE_UPDATE_FACEOBJECTS_START = "FACE_UPDATE_FACEOBJECTS_START";
export const FACE = "SHARE_UPDATE_FACEOBJECTS_START";
export const FACE_SET_LOADING = "FACE_SET_LOADING";
export const FACE_SET_INIT_FACEOBJECTS = "SHARE_SET_INIT_FACEOBJECTS";
export const FACE_UPLOAD_START = "FACE_UPLOAD_START";

//AI
export const AI_UPDATE_AIOBJECTS = "AI_UPDATE_AIOBJECTS";
export const AI_SET_LOADING = "AI_SET_LOADING";

//StorageState
export const STORAGESTATE_UPDATE_STORAGESTATEOBJECTS = "STORAGESTATE_UPDATE_STORAGESTATEOBJECTS";
export const STORAGESTATE_SET_LOADING = "STORAGESTATE_SET_LOADING";

// Cut
export const CUT_SET_TIMELINE_LENGTH = "CUT_SET_TIMELINE_LENGTH";
export const CUT_SET_LEFT_MARKER = "CUT_SET_LEFT_MARKER";
export const CUT_SET_RIGHT_MARKER = "CUT_SET_RIGHT_MARKER";
export const CUT_RESET = "CUT_RESET";

//Article action types
export const ARTICLES_GET_START = "ARTICLES_GET_START";
export const ARTICLES_GET_SUCCESS = "ARTICLES_GET_SUCCESS";
export const ARTICLES_GET_FAIL = "ARTICLES_GET_FAIL";
export const ARTICLES_DELETE_START = "ARTICLES_DELETE_START";
export const ARTICLES_DELETE_SUCCESS = "ARTICLES_DELETE_SUCCESS";
export const ARTICLES_DELETE_FAIL = "ARTICLES_DELETE_FAIL";
export const ARTICLES_SAVE_NEW_START = "ARTICLES_SAVE_NEW_START";
export const ARTICLES_SAVE_NEW_SUCCESS = "ARTICLES_SAVE_NEW_SUCCESS";
export const ARTICLES_SAVE_NEW_FAIL = "ARTICLES_SAVE_NEW_FAIL";
export const ARTICLES_REMOVE_CLIPS_START = "ARTICLES_REMOVE_CLIPS_START";
export const ARTICLES_REMOVE_CLIPS_SUCCESS = "ARTICLES_REMOVE_CLIPS_SUCCESS";
export const ARTICLES_REMOVE_CLIPS_FAIL = "ARTICLES_REMOVE_CLIPS_FAIL";
export const ARTICLES_SET_CURRENT = "ARTICLES_SET_CURRENT";
export const ARTICLES_SET_ACTIVE = "ARTICLES_SET_ACTIVE";
export const ARTICLES_SEARCH_SUCCESS = "ARTICLES_SEARCH_SUCCESS";
export const ARTICLES_SEARCH_FAIL = "ARTICLES_SEARCH_FAIL";
export const ARTICLES_SEARCH_REPORT_START = "ARTICLES_SEARCH_REPORT_START";
export const ARTICLES_SEARCH_REPORT_SUCCESS = "ARTICLES_SEARCH_REPORT_SUCCESS";
export const ARTICLES_SEARCH_REPORT_FAIL = "ARTICLES_SEARCH_REPORT_FAIL";
export const ARTICLES_EDIT_REPORT_START = "ARTICLES_EDIT_REPORT_START";
export const ARTICLES_EDIT_REPORT_SUCCESS = "ARTICLES_EDIT_REPORT_SUCCESS";
export const ARTICLES_EDIT_REPORT_FAIL = "ARTICLES_EDIT_REPORT_FAIL";
export const ARTICLES_PUBLISH_ARTICLE_START = "ARTICLES_PUBLISH_ARTICLE_START";
export const ARTICLES_PUBLISH_ARTICLE_SUCCESS = "ARTICLES_PUBLISH_ARTICLE_SUCCESS";
export const ARTICLES_PUBLISH_ARTICLE_FAIL = "ARTICLES_PUBLISH_ARTICLE_FAIL";

//Article Tree
export const GET_ARTICLE_TREE_START = "GET_ARTICLE_TREE_START";
export const GET_ARTICLE_TREE_SUCCESS = "GET_ARTICLE_TREE_SUCCESS";
export const GET_ARTICLE_TREE_FAIL = "GET_ARTICLE_TREE_FAIL";
export const GET_ARTICLE_BY_DIST_START = "GET_ARTICLE_BY_DIST_START";
export const GET_ARTICLE_BY_DIST_SUCCESS = "GET_ARTICLE_BY_DIST_SUCCESS";
export const GET_ARTICLE_BY_DIST_FAIL = "GET_ARTICLE_BY_DIST_FAIL";
export const ARTICLE_CHILD_ADD_START = "ARTICLE_CHILD_ADD_START";
export const ARTICLE_CHILD_ADD_SUCCESS = "ARTICLE_CHILD_ADD_SUCCESS";
export const ARTICLE_CHILD_ADD_FAIL = "ARTICLE_CHILD_ADD_FAIL";
export const ARTICLE_REMOVE_CLIPS_START = "ARTICLE_REMOVE_CLIPS_START";
export const ARTICLE_REMOVE_CLIPS_SUCCESS = "ARTICLE_REMOVE_CLIPS_SUCCESS";
export const ARTICLE_REMOVE_CLIPS_FAIL = "ARTICLE_REMOVE_CLIPS_FAIL";
export const ARTICLE_REMOVE_PROJECT_FAIL = "ARTICLE_REMOVE_PROJECT_FAIL";
export const ARTICLE_REMOVE_PROJECT_START = "ARTICLE_REMOVE_PROJECT_START";

//UploadProjects
export const UPLOADPROJECTS_NEW_PROJECT_START = "UPLOADPROJECT_NEW_PROJECT_START";
export const UPLOADPROJECTS_NEW_PROJECT_FAIL = "UPLOADPROJECT_NEW_PROJECT_START";
export const UPLOADPROJECTS_NEW_PROJECT_SUCCESS = "UPLOADPROJECT_NEW_PROJECT_START";
export const UPLOADPROJECTS_SAVE_NEW_PROJECT = "UPLOADPROJECTS_SAVE_NEW_PROJECT";
export const UPLOADPROJECTS_GET_PROJECTS_START = "UPLOADPROJECTS_GET_PROJECTS_START";
export const UPLOADPROJECTS_GET_PROJECTS_SUCCESS = "UPLOADPROJECTS_GET_PROJECTS_SUCCESS";
export const UPLOADPROJECTS_GET_PROJECTS_FAIL = "UPLOADPROJECTS_GET_PROJECTS_FAIL";
export const UPLOADPROJECTS_GET_DELETED_PROJECTS_START = "UPLOADPROJECTS_GET_DELETED_PROJECTS_START";
export const UPLOADPROJECTS_GET_DELETED_PROJECTS_SUCCESS = "UPLOADPROJECTS_GET_DELETED_PROJECTS_SUCCESS";
export const UPLOADPROJECTS_GET_DELETED_PROJECTS_FAIL = "UPLOADPROJECTS_GET_DELETED_PROJECTS_FAIL";
export const UPLOADPROJECTS_DELETE_PROJECT_START = "UPLOADPROJECTS_DELETE_PROJECT_START";
export const UPLOADPROJECTS_DELETE_PROJECT_SUCCESS = "UPLOADPROJECTS_DELETE_PROJECT_SUCCESS";
export const UPLOADPROJECTS_DELETE_PROJECT_FAIL = "UPLOADPROJECTS_DELETE_PROJECT_FAIL";
export const UPLOADPROJECTS_SET_ACTIVE_PROJECT = "UPLOADPROJECTS_SET_ACTIVE_PROJECT";
export const UPLOADPROJECTS_PROJECT_UPDATE_RECEIVED = "UPLOADPROJECTS_PROJECT_UPDATE_RECEIVED";
export const UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_START = "UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_START";
export const UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_FAIL = "UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_FAIL";
export const UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_SUCCESS = "UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_SUCCESS";
export const UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_START = "UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_START";
export const UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_FAIL = "UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_FAIL";
export const UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_SUCCESS = "UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_SUCCESS";
export const UPLOADPROJECTS_PROJECT_REMOVE_LINKS_START = "UPLOADPROJECTS_PROJECT_REMOVE_LINKS_START";
export const UPLOADPROJECTS_PROJECT_REMOVE_LINKS_SUCCESS = "UPLOADPROJECTS_PROJECT_REMOVE_LINKS_SUCCESS";
export const UPLOADPROJECTS_PROJECT_REMOVE_LINKS_FAIL = "UPLOADPROJECTS_PROJECT_REMOVE_LINKS_FAIL";
export const UPLOADPROJECTS_GET_SCHEMES_START = "UPLOADPROJECTS_GET_SCHEMES_START";
export const UPLOADPROJECTS_GET_SCHEMES_SUCCESS = "UPLOADPROJECTS_GET_SCHEMES_SUCCESS";
export const UPLOADPROJECTS_GET_SCHEMES_FAIL = "UPLOADPROJECTS_GET_SCHEMES_FAIL";
export const UPLOADPROJECTS_SET_CURRENT_UPLOADPROJECT = "UPLOADPROJECTS_SET_CURRENT_UPLOADPROJECT";
export const UPLOADPROJECTS_SET_LOADING = "UPLOADPROJECTS_SET_LOADING";

// UploadProjectTree
export const UPLOADPROJECTS_GET_PROJECT_TREE_START = "UPLOADPROJECTS_GET_PROJECT_TREE_START";
export const UPLOADPROJECTS_GET_PROJECT_TREE_SUCCESS = "UPLOADPROJECTS_GET_PROJECT_TREE_SUCCESS";
export const UPLOADPROJECTS_GET_PROJECT_TREE_FAIL = "UPLOADPROJECTS_GET_PROJECT_TREE_FAIL";
export const UPLOADPROJECTS_CHILD_ADD_START = "UPLOADPROJECTS_CHILD_ADD_START";
export const UPLOADPROJECTS_CHILD_ADD_SUCCESS = "UPLOADPROJECTS_CHILD_ADD_SUCCESS";
export const UPLOADPROJECTS_CHILD_ADD_FAIL = "UPLOADPROJECTS_CHILD_ADD_FAIL";

//LaneTree
export const LANES_GET_PROJECT_TREE_START = "LANES_GET_PROJECT_TREE_START";
export const LANES_GET_PROJECT_TREE_SUCCESS = "LANES_GET_PROJECT_TREE_SUCCESS";
export const LANES_GET_PROJECT_TREE_FAIL = "LANES_GET_PROJECT_TREE_FAIL";
export const LANES_SET_LOADING = "LANES_SET_LOADING";
export const LANES_UPDATE_OBJECTS_SUCCESS = "LANES_UPDATE_OBJECTS_SUCCESS";

//TvLaneTree
export const TVLANES_GET_PROJECT_TREE_START = "TVLANES_GET_PROJECT_TREE_START";
export const TVLANES_GET_PROJECT_TREE_SUCCESS = "TVLANES_GET_PROJECT_TREE_SUCCESS";
export const TVLANES_GET_PROJECT_TREE_FAIL = "TVLANES_GET_PROJECT_TREE_FAIL";
export const TVLANES_SET_LOADING = "TVLANES_SET_LOADING";
export const TVLANES_UPDATE_OBJECTS_SUCCESS = "TVLANES_UPDATE_OBJECTS_SUCCESS";
export const TVLANES_UPDATE_MEDIAOBJECTS_SUCCESS = "TVLANES_UPDATE_MEDIAOBJECTS_SUCCESS";
//EventRooms
export const EVENTROOMS_NEW_PROJECT_START = "EVENTROOMS_NEW_PROJECT_START";
export const EVENTROOMS_NEW_PROJECT_FAIL = "EVENTROOMS_NEW_PROJECT_START";
export const EVENTROOMS_NEW_PROJECT_SUCCESS = "EVENTROOMS_NEW_PROJECT_START";
export const EVENTROOMS_SAVE_NEW_PROJECT = "EVENTROOMS_SAVE_NEW_PROJECT";
export const EVENTROOMS_GET_PROJECTS_START = "EVENTROOMS_GET_PROJECTS_START";
export const EVENTROOMS_GET_PROJECTS_SUCCESS = "EVENTROOMS_GET_PROJECTS_SUCCESS";
export const EVENTROOMS_GET_PROJECTS_FAIL = "EVENTROOMS_GET_PROJECTS_FAIL";
export const EVENTROOMS_GET_DELETED_PROJECTS_START = "EVENTROOMS_GET_DELETED_PROJECTS_START";
export const EVENTROOMS_GET_DELETED_PROJECTS_SUCCESS = "EVENTROOMS_GET_DELETED_PROJECTS_SUCCESS";
export const EVENTROOMS_GET_DELETED_PROJECTS_FAIL = "EVENTROOMS_GET_DELETED_PROJECTS_FAIL";
export const EVENTROOMS_DELETE_PROJECT_START = "EVENTROOMS_DELETE_PROJECT_START";
export const EVENTROOMS_DELETE_PROJECT_SUCCESS = "EVENTROOMS_DELETE_PROJECT_SUCCESS";
export const EVENTROOMS_DELETE_PROJECT_FAIL = "EVENTROOMS_DELETE_PROJECT_FAIL";
export const EVENTROOMS_SET_ACTIVE_PROJECT = "EVENTROOMS_SET_ACTIVE_PROJECT";
export const EVENTROOMS_PROJECT_UPDATE_RECEIVED = "EVENTROOMS_PROJECT_UPDATE_RECEIVED";
export const EVENTROOMS_ADD_CLIPS_TO_PROJECT_START = "EVENTROOMS_ADD_CLIPS_TO_PROJECT_START";
export const EVENTROOMS_ADD_CLIPS_TO_PROJECT_FAIL = "EVENTROOMS_ADD_CLIPS_TO_PROJECT_FAIL";
export const EVENTROOMS_ADD_CLIPS_TO_PROJECT_SUCCESS = "EVENTROOMS_ADD_CLIPS_TO_PROJECT_SUCCESS";
export const EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_START = "EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_START";
export const EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_FAIL = "EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_FAIL";
export const EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_SUCCESS = "EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_SUCCESS";
export const EVENTROOMS_PROJECT_REMOVE_LINKS_START = "EVENTROOMS_PROJECT_REMOVE_LINKS_START";
export const EVENTROOMS_PROJECT_REMOVE_LINKS_SUCCESS = "EVENTROOMS_PROJECT_REMOVE_LINKS_SUCCESS";
export const EVENTROOMS_PROJECT_REMOVE_LINKS_FAIL = "EVENTROOMS_PROJECT_REMOVE_LINKS_FAIL";
export const EVENTROOMS_GET_SCHEMES_START = "EVENTROOMS_GET_SCHEMES_START";
export const EVENTROOMS_GET_SCHEMES_SUCCESS = "EVENTROOMS_GET_SCHEMES_SUCCESS";
export const EVENTROOMS_GET_SCHEMES_FAIL = "EVENTROOMS_GET_SCHEMES_FAIL";
export const EVENTROOMS_SET_CURRENT_UPLOADPROJECT = "EVENTROOMS_SET_CURRENT_UPLOADPROJECT";
export const EVENTROOMS_SET_LOADING = "EVENTROOMS_SET_LOADING";
export const EVENTROOMS_SET_METALANG = "EVENTROOMS_SET_METALANG";

// EventRoomTree
export const EVENTROOMS_GET_PROJECT_TREE_START = "EVENTROOMS_GET_PROJECT_TREE_START";
export const EVENTROOMS_GET_PROJECT_TREE_SUCCESS = "EVENTROOMS_GET_PROJECT_TREE_SUCCESS";
export const EVENTROOMS_GET_PROJECT_TREE_FAIL = "EVENTROOMS__GET_PROJECT_TREE_FAIL";
export const EVENTROOMS_CHILD_ADD_START = "EVENTROOMS_CHILD_ADD_START";
export const EVENTROOMS_CHILD_ADD_SUCCESS = "EVENTROOMS_CHILD_ADD_SUCCESS";
export const EVENTROOMS_CHILD_ADD_FAIL = "EVENTROOMS_CHILD_ADD_FAIL";


//Auth action types
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const AUTH_SESSION_LOGIN_START = "AUTH_SESSION_LOGIN_START"
export const AUTH_SESSION_LOGIN_SUCCESS = "AUTH_SESSION_LOGIN_SUCCESS";
export const AUTH_SESSION_LOGIN_FAIL = "AUTH_SESSION_LOGIN_FAIL";
export const AUTH_SWITCH_GROUP_START = "AUTH_SWITCH_GROUP_START";
export const AUTH_SWITCH_GROUP_SUCCESS = "AUTH_SWITCH_GROUP_SUCCESS";
export const AUTH_SWITCH_GROUP_FAIL = "AUTH_SWITCH_GROUP_FAIL";
export const AUTH_LOGOUT_START = "AUTH_LOGOUT_START";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const AUTH_LOGOUT_FAIL = "AUTH_LOGOUT_FAIL";
export const AUTH_NO_LOGIN = "AUTH_NO_LOGIN";

//UI action types
export const UI_RESTORE = "UI_RESTORE";
export const UI_LEFT_SIDEBAR_OPENED = "UI_LEFT_SIDEBAR_OPENED";
export const UI_LEFT_SIDEBAR_CLOSED = "UI_LEFT_SIDEBAR_CLOSED";
export const UI_LEFT_SIDEBAR_OPENING = "UI_LEFT_SIDEBAR_OPENING";
export const UI_LEFT_SIDEBAR_CLOSING = "UI_LEFT_SIDEBAR_CLOSING";
export const UI_CHANGE_LANGUAGE = "UI_CHANGE_LANGUAGE";
export const UI_TOGGLE_FILTER = "UI_TOGGLE_FILTER";
export const UI_METADATA_OPENED = "UI_METADATA_OPENED";
export const UI_METADATA_CLOSED = "UI_METADATA_CLOSED";

export const UI_PANEL_OPEN = "UI_PANEL_OPEN";
export const UI_PANEL_CLOSE = "UI_PANEL_CLOSE";

export const UI_SET_CLIPLIST_VIEW_MODE = "UI_SET_CLIPLIST_VIEW_MODE";
export const UI_UPLOAD_OPENED = "UI_UPLOAD_OPENED";
export const UI_UPLOAD_CLOSED = "UI_UPLOAD_CLOSED";
export const UI_UPLOAD_OPENING = "UI_UPLOAD_OPENING";
export const UI_UPLOAD_ADD_DRAGDROP = "UI_UPLOAD_ADD_DRAGDROP";
export const LOAD_UI_CONFIG_START = "LOAD_UI_CONFIG_START";
export const LOAD_UI_CONFIG_SUCCESS = "LOAD_UI_CONFIG_SUCCESS";
export const LOAD_UI_CONFIG_FAIL = "LOAD_UI_CONFIG_FAIL";

//WebApi
/*export const WEBAPI_POSTMESAGE_START = 'WEBAPI_POSTMESAGE_START';
export const WEBAPI_POSTMESSAGE_SUCCESS = 'WEBAPI_POSTMESSAGE_SUCCESS';
export const WEBAPI_POSTMESSAGE_FAIL = 'WEBAPI_POSTMESSAGE_FAIL';*/
export const UI_POST_WEBAPIMESSAGE = "UI_POST_WEBAPIMESSAGE";
export const UI_DELETE_WEBAPIMESSAGE = "UI_DELETE_WEBAPIMESSAGE";
export const UI_POST_WEBAPIMEDIA = "UI_POST_WEBAPIMEDIA";
export const UI_SAVE_WEBAPI_FILEPATH = "UI_SAVE_WEBAPI_FILEPATH";

//TagsTree
export const UI_SAVE_SELECTEDTAGS = "UI_SAVE_SELECTEDTAGS";
export const UI_SAVE_SELECTEDMODELS = "UI_SAVE_SELECTEDMODELS";
export const UI_ADD_APITAGS = "UI_ADD_APITAGS";
export const UI_ADD_APIMODELS = "UI_ADD_APIMODELS";
export const UI_ADD_APICONSUMPTION = "UI_ADD_APICONSUMPTION";

//AppsConfig
export const UI_ADD_APIAPPSCONFIG = "UI_ADD_APIAPPSCONFIG";
export const UI_ADD_APIUPLOADCONFIG = "UI_ADD_APIUPLOADCONFIG";
export const UI_ADD_APIEXPERTSEARCHCONFIG = "UI_ADD_APIEXPERTSEARCHCONFIG";

//TempFormConfig
export const UI_ADD_TEMPCONFIG = "UI_ADD_TEMPCONFIG";
export const UI_TEMP_SAVEDATA = "UI_TEMP_SAVEDATA";
export const UI_TEMP_OPENED = "UI_TEMP_OPENED";
export const UI_TEMP_CLOSED = "UI_TEMP_CLOSED";

export const UI_EXPERT_SEARCH_OPENED = "UI_EXPERT_SEARCH_OPENED";
export const UI_EXPERT_SEARCH_CLOSED = "UI_EXPERT_SEARCH_CLOSED";
export const UI_EXPERT_SEARCH_SAVEDATA = "UI_EXPERT_SEARCH_SAVEDATA";
export const UI_EXPERT_SEARCH_SETUPDATA = "UI_EXPERT_SEARCH_SETUPDATA";
//Select Language
export const UI_SELECT_LANGUAGE = "SELECT_LANGUAGE";
// windows
export const UI_SET_WINDOW = "UI_SET_WINDOW";
export const UI_REMOVE_WINDOW = "UI_REMOVE_WINDOW";

//Countries
export const UI_DISPLAY_COUNTRIES = "UI_DISPLAY_COUNTRIES";
export const UI_SELECT_COUNTRIES = "UI_SELECT_COUNTRIES";
export const UI_REMOVE_COUNTRIES = "UI_REMOVE_COUNTRIES";
export const UI_REMOVE_ALLCOUNTRIES = "UI_REMOVE_ALLCOUNTRIES";

//Sortorder
export const SET_SORTORDER = "SET_SORTORDER";

//Home action types
export const HOME_FETCH_START = "HOME_FETCH_START";
export const HOME_FETCH_SUCCESS = "HOME_FETCH_SUCCESS";
export const HOME_FETCH_ERROR = "HOME_FETCH_ERROR";

//Projects action types
export const SELECT_PROJECT = "SELECT_PROJECT";
export const ADD_CLIP_TO_PROJECT_START = "ADD_CLIP_TO_PROJECT_START";
export const ADD_CLIP_TO_PROJECT_FAIL = "ADD_CLIP_TO_PROJECT_FAIL";
export const ADD_CLIP_TO_PROJECT_SUCCESS = "ADD_CLIP_TO_PROJECT_SUCCESS";
export const ADD_CLIPS_TO_PROJECT_START = "ADD_CLIPS_TO_PROJECT_START";
export const ADD_CLIPS_TO_PROJECT_FAIL = "ADD_CLIPS_TO_PROJECT_FAIL";
export const ADD_CLIPS_TO_PROJECT_SUCCESS = "ADD_CLIPS_TO_PROJECT_SUCCESS";
export const REMOVE_CLIP_FROM_PROJECT_START = "REMOVE_CLIP_FROM_PROJECT_START";
export const REMOVE_CLIP_FROM_PROJECT_FAIL = "REMOVE_CLIP_FROM_PROJECT_FAIL";
export const REMOVE_CLIP_FROM_PROJECT_SUCCESS =
  "REMOVE_CLIP_FROM_PROJECT_SUCCESS";
export const REMOVE_CLIPS_FROM_PROJECT_START =
  "REMOVE_CLIPS_FROM_PROJECT_START";
export const REMOVE_CLIPS_FROM_PROJECT_FAIL = "REMOVE_CLIPS_FROM_PROJECT_FAIL";
export const REMOVE_CLIPS_FROM_PROJECT_SUCCESS =
  "REMOVE_CLIPS_FROM_PROJECT_SUCCESS";
export const GET_PROJECTS_START = "GET_PROJECTS_START";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_FAIL = "GET_PROJECTS_FAIL";
export const GET_PROJECT_CLIPS_START = "GET_PROJECT_CLIPS_START";
export const GET_PROJECT_CLIPS_SUCCESS = "GET_PROJECT_CLIPS_SUCCESS";
export const GET_PROJECT_CLIPS_FAIL = "GET_PROJECT_CLIPS_FAIL";
export const SET_ACTIVE_PROJECT = "SET_ACTIVE_PROJECT";
export const NEW_PROJECT_START = "NEW_PROJECT_START";
export const NEW_PROJECT_FAIL = "NEW_PROJECT_START";
export const NEW_PROJECT_SUCCESS = "NEW_PROJECT_START";
export const DELETE_PROJECT_START = "DELETE_PROJECT_START";
export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
export const DELETE_PROJECT_FAIL = "DELETE_PROJECT_FAIL";
export const COPY_PROJECT_START = "COPY_PROJECT_START";
export const COPY_PROJECT_SUCCESS = "COPY_PROJECT_SUCCESS";
export const COPY_PROJECT_FAIL = "COPY_PROJECT_FAIL";
export const PROJECT_UPDATE_RECEIVED = "PROJECT_UPDATE_RECEIVED";
export const PROJECT_REMOVE_LINKS_START = "PROJECT_REMOVE_LINKS_START";
export const PROJECT_REMOVE_LINKS_SUCCESS = "PROJECT_REMOVE_LINKS_SUCCESS";
export const PROJECT_REMOVE_LINKS_FAIL = "PROJECT_REMOVE_LINKS_FAIL";

export const GET_DELETED_PROJECTS_START = "GET_DELETED_PROJECTS_START";
export const GET_DELETED_PROJECTS_SUCCESS = "GET_DELETED_PROJECTS_SUCCESS";
export const GET_DELETED_PROJECTS_FAIL = "GET_DELETED_PROJECTS_FAIL";

// ProjectTree
export const GET_PROJECT_TREE_START = "GET_PROJECT_TREE_START";
export const GET_PROJECT_TREE_SUCCESS = "GET_PROJECT_TREE_SUCCESS";
export const GET_PROJECT_TREE_FAIL = "GET_PROJECT_TREE_FAIL";
export const PROJECT_CHILD_ADD_START = "PROJECT_CHILD_ADD_START";
export const PROJECT_CHILD_ADD_SUCCESS = "PROJECT_CHILD_ADD_SUCCESS";
export const PROJECT_CHILD_ADD_FAIL = "PROJECT_CHILD_ADD_FAIL";

// SeriesTree
export const SERIES_LOAD_START = "SERIES_LOAD_START";
export const SERIES_LOAD_SUCCESS = "SERIES_LOAD_SUCCESS";
export const SERIES_LOAD_FAIL = "SERIES_LOAD_FAIL";
export const SERIES_SET_ACTIVE = "SERIES_SET_ACTIVE";
export const SERIES_GET_CLIPS_START = "SERIES_GET_CLIPS_START";
export const SERIES_GET_CLIPS_SUCCESS = "SERIES_GET_CLIPS_SUCCESS";
export const SERIES_GET_CLIPS_FAIL = "SERIES_GET_CLIPS_FAIL";
export const SERIES_DELETE_START = "SERIES_DELETE_START";
export const SERIES_DELETE_SUCCESS = "SERIES_DELETE_SUCCESS";
export const SERIES_DELETE_FAIL = "SERIES_DELETE_FAIL";

//Actions action types
export const GET_FLOWACTIONS_START = "GET_FLOWACTIONS_START";
export const GET_FLOWACTIONS_SUCCESS = "GET_FLOWACTIONS_SUCCESS";
export const GET_FLOWACTIONS_FAIL = "GET_FLOWACTIONS_FAIL";

// Distribution Tree
export const GET_DISTRIBUTION_TREE_START = "GET_DISTRIBUTION_TREE_START";
export const GET_DISTRIBUTION_TREE_SUCCESS = "GET_DISTRIBUTION_TREE_SUCCESS";
export const GET_DISTRIBUTION_TREE_FAIL = "GET_DISTRIBUTION_TREE_FAIL";
export const GET_DISTRIBUTION_BY_DIST_START = "GET_DISTRIBUTION_BY_DIST_START";
export const GET_DISTRIBUTION_BY_DIST_SUCCESS = "GET_DISTRIBUTION_BY_DIST_SUCCESS";
export const GET_DISTRIBUTION_BY_DIST_FAIL = "GET_DISTRIBUTION_BY_DIST_FAIL";
export const DISTRIBUTION_CHILD_ADD_START = "DISTRIBUTION_CHILD_ADD_START";
export const DISTRIBUTION_CHILD_ADD_SUCCESS = "DISTRIBUTION_CHILD_ADD_SUCCESS";
export const DISTRIBUTION_CHILD_ADD_FAIL = "DISTRIBUTION_CHILD_ADD_FAIL";
export const DISTRIBUTION_REMOVE_CLIPS_START = "DISTRIBUTION_REMOVE_CLIPS_START";
export const DISTRIBUTION_REMOVE_CLIPS_SUCCESS = "DISTRIBUTION_REMOVE_CLIPS_SUCCESS";
export const DISTRIBUTION_REMOVE_CLIPS_FAIL = "DISTRIBUTION_REMOVE_CLIPS_FAIL";
export const DISTRIBUTION_ADD_CLIPS_START = "DISTRIBUTION_ADD_CLIPS_START";
export const DISTRIBUTION_ADD_CLIPS_SUCCESS = "DISTRIBUTION_ADD_CLIPS_SUCCESS";
export const DISTRIBUTION_ADD_CLIPS_FAIL = "DISTRIBUTION_ADD_CLIPS_FAIL";
export const DISTRIBUTION_REMOVE_PROJECT_FAIL = "DISTRIBUTION_REMOVE_PROJECT_FAIL";
export const DISTRIBUTION_REMOVE_PROJECT_START = "DISTRIBUTION_REMOVE_PROJECT_START";
export const DISTRIBUTION_REORDER_START = "DISTRIBUTION_REORDER_START";
export const DISTRIBUTION_REORDER_SUCCESS = "DISTRIBUTION_REORDER_SUCCESS";

export const DISTRIBUTION_GET_BY_ID_START = "DISTRIBUTION_GET_BY_ID_START";
export const DISTRIBUTION_GET_BY_ID_SUCCESS = "DISTRIBUTION_GET_BY_ID_SUCCESS";
export const DISTRIBUTION_GET_BY_ID_FAIL = "DISTRIBUTION_GET_BY_ID_FAIL";

export const DISTRIBUTION_METADATA_UPDATE = "DISTRIBUTION_METADATA_UPDATE";

export const GET_DISTRIBUTIONS_BY_TYPE_START = "GET_DISTRIBUTIONS_BY_TYPE_START";
export const GET_DISTRIBUTIONS_BY_TYPE_SUCCESS = "GET_DISTRIBUTIONS_BY_TYPE_SUCCESS";
export const GET_DISTRIBUTIONS_BY_TYPE_FAIL = "GET_DISTRIBUTIONS_BY_TYPE_FAIL";

// Newsroom Tree
export const GET_NEWSROOM_TREE_START = "GET_NEWSROOM_TREE_START";
export const GET_NEWSROOM_TREE_SUCCESS = "GET_NEWSROOM_TREE_SUCCESS";
export const GET_NEWSROOM_TREE_FAIL = "GET_NEWSROOM_TREE_FAIL";
export const GET_NEWSROOM_BY_NEWSROOM_START = "GET_NEWSROOM_BY_NEWSROOM_START";
export const GET_NEWSROOM_BY_NEWSROOM_SUCCESS = "GET_NEWSROOM_BY_NEWSROOM_SUCCESS";
export const GET_NEWSROOM_BY_NEWSROOM_FAIL = "GET_NEWSROOM_BY_NEWSROOM_FAIL";
export const NEWSROOM_CHILD_ADD_START = "NEWSROOM_CHILD_ADD_START";
export const NEWSROOM_CHILD_ADD_SUCCESS = "NEWSROOM_CHILD_ADD_SUCCESS";
export const NEWSROOM_CHILD_ADD_FAIL = "NEWSROOM_CHILD_ADD_FAIL";
export const NEWSROOM_REMOVE_CLIPS_START = "NEWSROOM_REMOVE_CLIPS_START";
export const NEWSROOM_REMOVE_CLIPS_SUCCESS = "NEWSROOM_REMOVE_CLIPS_SUCCESS";
export const NEWSROOM_REMOVE_CLIPS_FAIL = "NEWSROOM_REMOVE_CLIPS_FAIL";
export const NEWSROOM_SET_ACTIVE = "NEWSROOM_SET_ACTIVE";
export const NEW_NEWSROOM_START = "NEW_NEWSROOM_START";
export const NEW_NEWSROOM_SUCCESS = "NEW_NEWSROOM_SUCCESS";
export const NEW_NEWSROOM_FAIL = "NEW_NEWSROOM_FAIL";
export const DELETE_NEWSROOM_START = "DELETE_NEWSROOM_START";
export const DELETE_NEWSROOM_SUCCESS = "DELETE_NEWSROOM_SUCCESS";
export const DELETE_NEWSROOM_FAIL = "DELETE_NEWSROOM_FAIL";

//Distributions action types
export const GET_DISTRIBUTIONS_START = "GET_DISTRIBUTIONS_START";
export const GET_DISTRIBUTIONS_SUCCESS = "GET_DISTRIBUTIONS_SUCCESS";
export const GET_DISTRIBUTIONS_FAIL = "GET_DISTRIBUTIONS_FAIL";
export const SET_CURRENT_DISTRIBUTION = "SET_CURRENT_DISTRIBUTION";
export const SET_ACTIVE_DISTRIBUTION = "SET_ACTIVE_DISTRIBUTION";
export const TWITTER_GET_TWEETS = "TWITTER_GET_TWEETS";
export const TWITTER_GET_TWEETS_SUCCESS = "TWITTER_GET_TWEETS_SUCCESS";

//Rooms action types
export const SELECT_ROOM = "SELECT_ROOM";
export const ADD_CLIP_TO_ROOM_START = "ADD_CLIP_TO_ROOM_START";
export const ADD_CLIP_TO_ROOM_FAIL = "ADD_CLIP_TO_ROOM_FAIL";
export const ADD_CLIP_TO_ROOM_SUCCESS = "ADD_CLIP_TO_ROOM_SUCCESS";
export const REMOVE_CLIP_FROM_ROOM_START = "REMOVE_CLIP_FROM_ROOM_START";
export const REMOVE_CLIP_FROM_ROOM_FAIL = "REMOVE_CLIP_FROM_ROOM_FAIL";
export const REMOVE_CLIP_FROM_ROOM_SUCCESS = "REMOVE_CLIP_FROM_ROOM_SUCCESS";
export const REMOVE_CLIPS_FROM_ROOM_START = "REMOVE_CLIPS_FROM_ROOM_START";
export const REMOVE_CLIPS_FROM_ROOM_FAIL = "REMOVE_CLIPS_FROM_ROOM_FAIL";
export const REMOVE_CLIPS_FROM_ROOM_SUCCESS = "REMOVE_CLIPS_FROM_ROOM_SUCCESS";
export const GET_ROOMS_START = "GET_ROOMS_START";
export const GET_ROOMS_SUCCESS = "GET_ROOMS_SUCCESS";
export const GET_ROOMS_FAIL = "GET_ROOMS_FAIL";
export const GET_ROOM_CLIPS_START = "GET_ROOM_CLIPS_START";
export const GET_ROOM_CLIPS_SUCCESS = "GET_ROOM_CLIPS_SUCCESS";
export const GET_ROOM_CLIPS_FAIL = "GET_ROOM_CLIPS_FAIL";
export const SET_ACTIVE_ROOM = "SET_ACTIVE_ROOM";
export const NEW_ROOM_START = "NEW_ROOM_START";
export const NEW_ROOM_FAIL = "NEW_ROOM_START";
export const NEW_ROOM_SUCCESS = "NEW_ROOM_START";
export const DELETE_ROOM_START = "DELETE_ROOM_START";
export const DELETE_ROOM_SUCCESS = "DELETE_ROOM_SUCCESS";
export const DELETE_ROOM_FAIL = "DELETE_ROOM_FAIL";
export const COPY_ROOM_START = "COPY_ROOM_START";
export const COPY_ROOM_SUCCESS = "COPY_ROOM_SUCCESS";
export const COPY_ROOM_FAIL = "COPY_ROOM_FAIL";
export const ROOM_UPDATE_RECEIVED = "ROOM_UPDATE_RECEIVED";

export const GET_DELETED_ROOMS_START = "GET_DELETED_ROOMS_START";
export const GET_DELETED_ROOMS_SUCCESS = "GET_DELETED_ROOMS_SUCCESS";
export const GET_DELETED_ROOMS_FAIL = "GET_DELETED_ROOMS_FAIL";

export const DUPLICATE_ROOM_START = "DUPLICATE_ROOM_START";
export const DUPLICATE_ROOM_SUCCESS = "DUPLICATE_ROOM_SUCCESS";
export const DUPLICATE_ROOM_FAIL = "DUPLICATE_ROOM_FAIL";

export const ROOM_MAKE_ZIP_START = "ROOM_MAKE_ZIP_START";
export const ROOM_MAKE_ZIP_SUCCESS = "ROOM_MAKE_ZIP_SUCCESS";
export const ROOM_MAKE_ZIP_FAIL = "ROOM_MAKE_ZIP_FAIL";

//ClipList types
export const GET_CLIPLIST_START = "GET_CLIPLIST_START";
export const GET_CLIPLIST_SUCCESS = "GET_CLIPLIST_SUCCESS";
export const GET_CLIPLIST_FAIL = "GET_CLIPLIST_FAIL";
export const GET_CLIPLIST_BY_ID_SUCCESS = "GET_CLIPLIST_BY_ID_SUCCESS";
export const GET_CLIP_BY_ID_START = "GET_CLIP_BY_ID_START";
export const GET_CLIP_BY_ID_SUCCESS = "GET_CLIP_BY_ID_SUCCESS";
export const GET_CLIP_BY_ID_FAIL = "GET_CLIP_BY_ID_FAIL";
export const CLIP_UPDATE_RECEIVED = "CLIP_UPDATE_RECEIVED";
export const CLIPLIST_TOGGLE_FILTER = "CLIPLIST_TOGGLE_FILTER";
export const CLIPLIST_SET_FILTER = "CLIPLIST_SET_FILTER";
export const CLIPLIST_DOWNLOAD_START = "CLIPLIST_DOWNLOAD_START";
export const CLIPLIST_DOWNLOAD_FAIL = "CLIPLIST_DOWNLOAD_FAIL";
export const CLIPLIST_DOWNLOAD_SUCCESS = "CLIPLIST_DOWNLOAD_SUCCESS";
export const CLIPLIST_RESET_DOWNLOAD = "CLIPLIST_RESET_DOWNLOAD";
export const SET_CLIPLIST = "SET_CLIPLIST";
export const ARRANGE_CLIPLIST_START = "ARRANGE_CLIPLIST_START";
export const ARRANGE_CLIPLIST_AND_END = "ARRANGE_CLIPLIST_AND_END";
export const SAVE_ARRANGED_CLIPLIST_START = "SAVE_ARRANGED_CLIPLIST_START";
export const SAVE_ARRANGED_CLIPLIST_SUCCESS = "SAVE_ARRANGED_CLIPLIST_SUCCESS";
export const SAVE_ARRANGED_CLIPLIST_FAIL = "SAVE_ARRANGED_CLIPLIST_FAIL";
export const CLIPLIST_RESTORE_START = "CLIPLIST_RESTORE_START";
export const CLIPLIST_RESTORE_SUCCESS = "CLIPLIST_RESTORE_SUCCESS";
export const CLIPLIST_RESTORE_FAIL = "CLIPLIST_RESTORE_FAIL";
export const CLIPLIST_DELETE_START = "CLIPLIST_DELETE_START";
export const CLIPLIST_DELETE_SUCCESS = "CLIPLIST_DELETE_SUCCESS";
export const CLIPLIST_DELETE_FAIL = "CLIPLIST_DELETE_FAIL";
export const CHECK_TRANSCODING_START = "CHECK_TRANSCODING_START";
export const CHECK_TRANSCODING_END = "CHECK_TRANSCODING_END";
export const CHECK_TRANSCODING_SUCCESS = "CHECK_TRANSCODING_SUCCESS";
export const CLIPLIST_SET_PLAYER_DERIVATIVES = "CLIPLIST_SET_PLAYER_DERIVATIVES";
export const LOAD_CLIP_BY_INTERNAL_LINK = "LOAD_CLIP_BY_INTERNAL_LINK";
export const REMOVE_CLIP_BY_INTERNAL_LINK = "REMOVE_CLIP_BY_INTERNAL_LINK";
export const CLIPLIST_SETUP_LIST_FIELDS = "CLIPLIST_SETUP_LIST_FIELDS";
export const CLIPLIST_ZOOM = "CLIPLIST_ZOOM";


//Clip action types
export const SELECT_CLIP = "SELECT_CLIP";
export const TICK_CLIP = "TICK_CLIP";
export const UNTICK_CLIP = "UNTICK_CLIP";
export const RESET_TICKED_CLIPS = "RESET_TICKED_CLIPS";
export const CLIP_DRAG_START = "CLIP_DRAG_START";
export const CLIP_DRAG_END = "CLIP_DRAG_END";
export const CLIP_REMOVE_MULTISELECTED = "CLIP_REMOVE_MULTISELECTED";
export const CLIP_ADD_MULTISELECTED = "CLIP_ADD_MULTISELECTED";
export const RESET_MULTISELECTED = "RESET_MULTISELECTED";
export const MASS_EDIT_SELECTED = "MASS_EDIT_SELECTED";
export const RESET_MASS_EDIT_SELECTED = "RESET_MASS_EDIT_SELECTED";

export const CUT_CLIP_START = "CUT_CLIP_START";
export const CUT_CLIP_SUCCESS = "CUT_CLIP_SUCCESS";
export const CUT_CLIP_FAIL = "CUT_CLIP_FAIL";

export const SET_RELATED_CLIP = "SET_RELATED_CLIP";

export const CLIP_GRAB_MAINTHUMB_START = "CLIP_GRAB_MAINTHUMB_START";
export const CLIP_GRAB_MAINTHUMB_SUCCESS = "CLIP_GRAB_MAINTHUMB_SUCCESS";
export const CLIP_GRAB_MAINTHUMB_FAIL = "CLIP_GRAB_MAINTHUMB_FAIL";

//Search action types
export const SEARCH_START = "SEARCH_START";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAIL = "SEARCH_FAIL";
export const SEARCH_NEXT_START = "SEARCH_NEXT_START";
export const SEARCH_NEXT_SUCCESS = "SEARCH_NEXT_SUCCESS";
export const SEARCH_NEXT_FAIL = "SEARCH_NEXT_FAIL";
//LAMTEST BEGIN
export const SEARCH_SET_SORT_DEFAULT = "SEARCH_SET_SORT_DEFAULT";
export const SEARCH_SET_SORTORDER_DEFAULT = "SEARCH_SET_SORTORDER_DEFAULT";
//LAMTEST END

//Save new project types
export const SAVE_NEW_PROJECT = "SAVE_NEW_PROJECT";

//Upload file

export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_CANCEL = "UPLOAD_CANCEL";
export const UPLOAD_FILE_TO_ONECLIP = "UPLOAD_FILE_TO_ONECLIP";
export const UPLOAD_FILE_START = "UPLOAD_START";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_SUCCESS_MASTER = "UPLOAD_FILE_SUCCESS_MASTER";
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL";
export const UPLOAD_FILE_FAIL_MASTER = "UPLOAD_FILE_FAIL_MASTER";
export const UPLOAD_FILE_ABORTED = "UPLOAD_FILE_ABORTED";
export const UPLOAD_FILE_ABORTED_MASTER = "UPLOAD_FILE_ABORTED_MASTER";
export const UPLOAD_FILE_PROGRESS = "UPLOAD_FILE_PROGRESS";
export const UPLOAD_FILE_PROGRESS_MASTER = "UPLOAD_FILE_PROGRESS_MASTER";
export const UPLOAD_SET_STATE = "UPLOAD_SET_STATE";
export const UPLOAD_SET_STATE_MASTER = "UPLOAD_SET_STATE_MASTER";
export const UPLOAD_SAVE_UPLOADEDDATA = "UPLOAD_SAVE_UPLOADEDDATA";

// export const UPLOAD_IMPORT_FILE_START = "UPLOAD_IMPORT_FILE_START";
export const UPLOAD_IMPORT_FILE_FAIL = "UPLOAD_IMPORT_FILE_FAIL";
export const UPLOAD_IMPORT_FILE_FAIL_MASTER = "UPLOAD_IMPORT_FILE_FAIL_MASTER";

export const UPLOAD_EDIT_CLIP_START = "UPLOAD_EDIT_CLIP_START";
export const UPLOAD_EDIT_CLIP_FAIL = "UPLOAD_EDIT_CLIP_FAIL";
export const UPLOAD_EDIT_CLIP_SUCCESS = "UPLOAD_EDIT_CLIP_SUCCESS";

export const UPLOAD_PROJECT_ADD_CLIP_START = "UPLOAD_PROJECT_ADD_CLIP_START";
export const UPLOAD_PROJECT_ADD_CLIP_FAIL = "UPLOAD_PROJECT_ADD_CLIP_FAIL";
export const UPLOAD_PROJECT_ADD_CLIP_SUCCESS =
  "UPLOAD_PROJECT_ADD_CLIP_SUCCESS";
export const UPLOAD_ROOM_ADD_CLIP_FAIL = "UPLOAD_ROOM_ADD_CLIP_FAIL";
export const UPLOAD_ROOM_ADD_CLIP_SUCCESS = "UPLOAD_ROOM_ADD_CLIP_SUCCESS";

export const UPLOAD_FORM_STATE = "UPLOAD_FORM_STATE";
export const UPLOAD_UPDATE_METADATA = "UPLOAD_UPDATE_METADATA";


//ExpertSearch
export const EXPERT_SEARCH = "EXPERT_SEARCH_FILE";
export const EXPERT_SEARCH_START = "EXPERT_SEARCH_START";
export const EXPERT_SEARCH_SUCCESS = "EXPERT_SEARCH_SUCCESS";
export const EXPERT_SEARCH_FAIL = "EXPERT_SEARCH_FAIL";

//HOOTSUITE
export const HOOTSUITE_PLUGIN = "HOOTSUITE_PLUGIN";

//CUSTOMDATA
export const CUSTOM_SET_ADDFORM_STATE = "CUSTOM_SET_ADDFORM_STATE";
export const CUSTOM_SET_NEWDATA = "CUSTOM_SET_NEWDATA";
export const CUSTOM_SEND_EMAIL_START = "CUSTOM_SEND_EMAIL_START";
export const CUSTOM_SEND_EMAIL_SUCCESS = "CUSTOM_SEND_EMAIL_SUCCESS";
export const CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS = "CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS";
export const CUSTOM_SAVE_CURRENTUSER = "CUSTOM_SAVE_CURRENTUSER";
export const CUSTOM_SET_HISTORY = "CUSTOM_SET_HISTORY";
export const CUSTOM_SET_CURRENTCLIPDATA = "CUSTOM_SET_CURRENTCLIPDATA";
export const CUSTOM_SET_CURRENT_SORTOPTION = "CUSTOM_SET_CURRENT_SORTOPTION";
export const CUSTOM_GET_LAST_SEARCH = "CUSTOM_GET_LAST_SEARCH";
export const CUSTOM_SET_CURRENT_DIALOG = "CUSTOM_SET_CURRENT_DIALOG";
export const CUSTOM_RELOAD_PROJECT = "CUSTOM_RELOAD_PROJECT";
export const CUSTOM_SET_CURRENT_PROJECT = "CUSTOM_SET_CURRENT_PROJECT";
export const CUSTOM_SET_EMPTY_PROJECTS = "CUSTOM_SET_EMPTY_PROJECTS";
export const CUSTOM_SET_DELETED_PROJECTS = "CUSTOM_SET_DELETED_PROJECTS";
export const CUSTOM_SET_UPDATED_PROJECTS = "CUSTOM_SET_UPDATED_PROJECTS";
export const CUSTOM_SET_DELETED_ROOMS = "CUSTOM_SET_DELETED_ROOMS";
export const CUSTOM_GET_CONFIGCLIPINFO_FORAPP = "CUSTOM_GET_CONFIGCLIPINFO_FORAPP";
export const CUSTOM_SET_CURRENT_MAIN_FILTER = "CUSTOM_SET_CURRENT_MAIN_FILTER";
export const CUSTOM_SET_CURRENT_SUB_FILTER = "CUSTOM_SET_CURRENT_SUB_FILTER";
export const CUSTOM_SET_UPLOAD_INFO = "CUSTOM_SET_UPLOAD_INFO";
export const CUSTOM_SET_UPLOAD_INFO_MASTER = "CUSTOM_SET_UPLOAD_INFO_MASTER";
export const CUSTOM_SET_CURRENT_UPLOAD_COUNT = "CUSTOM_SET_CURRENT_UPLOAD_COUNT";
export const CUSTOM_SET_FULLTEXT_SEARCH_DATA = "CUSTOM_SET_FULLTEXT_SEARCH_DATA";
export const CUSTOM_SET_BYFIEDS_SEARCH_DATA = "CUSTOM_SET_BYFIEDS_SEARCH_DATA";
export const CUSTOM_SET_LAST_SEARCH_TYPE = "CUSTOM_SET_LAST_SEARCH_TYPE";
export const CUSTOM_SET_SEARCH_INFO = "CUSTOM_SET_SEARCH_INFO";
export const CUSTOM_TOGGLE_POPUP_HIDDEN = "CUSTOM_TOGGLE_POPUP_HIDDEN";
export const CUSTOM_GOOGLE_SIGN_IN = "CUSTOM_GOOGLE_SIGN_IN";
export const CUSTOM_GET_APP_DATA = "CUSTOM_GET_APP_DATA";
export const CUSTOM_GET_APP_DATA_START = "CUSTOM_GET_APP_DATA_START";
export const CUSTOM_GET_APP_DATA_SUCCESS = "CUSTOM_GET_APP_DATA_SUCCESS";
export const CUSTOM_CREATE_NEW_ENTRY_SUCCESS = "CUSTOM_CREATE_NEW_ENTRY_SUCCESS";
export const CUSTOM_SET_INITIAL_STATE = "CUSTOM_SET_INITIAL_STATE";
export const CUSTOM_CREATE_NEW_ENTRY_FAIL = "CUSTOM_CREATE_NEW_ENTRY_FAIL";
export const CUSTOM_GET_UICONFIG_FORAPP = "CUSTOM_GET_UICONFIG_FORAPP";
export const CUSTOM_MW_LOGOUT = "CUSTOM_MW_LOGOUT";
export const CUSTOM_CATCH_APP_ERRORS = "CUSTOM_CATCH_APP_ERRORS";
export const CUSTOM_SET_REPORTS_DATA = "CUSTOM_SET_REPORTS_DATA";
export const CUSTOM_GET_FLEX_APP_CONFIG = "CUSTOM_GET_FLEX_APP_CONFIG";
export const CUSTOM_GET_UL_CONSTRAINTS_SUCCESS = "CUSTOM_GET_UL_CONSTRAINTS_SUCCESS";

//ARTICLES
export const UPDATE_ARTICLE_OBJECTS = "UPDATE_ARTICLE_OBJECTS";

//Save new profile types
export const SAVE_NEW_PROFILE = "SAVE_NEW_PROFILE";

export const PROFILE_SAVE_USER = "PROFILE_SAVE_USER";
export const PROFILE_SAVE_USER_START = "PROFILE_SAVE_START";
export const PROFILE_SAVE_USER_SUCCESS = "PROFILE_SAVE_SUCCESS";
export const PROFILE_SAVE_USER_FAIL = "PROFILE_SAVE_FAIL";

export const PROFILE_GET_USER = "PROFILE_GET_USER";
export const PROFILE_GET_USER_START = "PROFILE_GET_USER_START";
export const PROFILE_GET_USER_SUCCESS = "PROFILE_GET_USER_SUCCESS";
export const PROFILE_GET_USER_FAIL = "PROFILE_GET_USER_FAIL";

export const PROFILE_EDIT_USER = "PROFILE_EDIT_USER";
export const PROFILE_EDIT_USER_START = "PROFILE_EDIT_USER_START";
export const PROFILE_EDIT_USER_SUCCESS = "PROFILE_EDIT_USER_SUCCESS";
export const PROFILE_EDIT_USER_FAIL = "PROFILE_EDIT_USER_FAIL";

export const PROFILE_RESET_ERROR = "PROFILE_RESET_ERROR";


//Metadata types
export const UPDATE_METADATA_CLIP_START = "UPDATE_METADATA_CLIP_START";
export const UPDATE_METADATA_CLIP_SUCCESS = "UPDATE_METADATA_CLIP_SUCCESS";
export const UPDATE_METADATA_CLIP_FAIL = "UPDATE_METADATA_CLIP_FAIL";
export const UPDATE_METADATA_PROJECT_START = "UPDATE_METADATA_PROJECT_START";
export const UPDATE_METADATA_PROJECT_SUCCESS = "UPDATE_METADATA_PROJECT_SUCCESS";
export const UPDATE_METADATA_PROJECT_FAIL = "UPDATE_METADATA_PROJECT_FAIL";
export const UPDATE_METADATA_DISTRIBUTION_START = "UPDATE_METADATA_DISTRIBUTION_START";
export const UPDATE_METADATA_DISTRIBUTION_SUCCESS = "UPDATE_METADATA_DISTRIBUTION_SUCCESS";
export const UPDATE_METADATA_DISTRIBUTION_FAIL = "UPDATE_METADATA_DISTRIBUTION_FAIL";
export const UPDATE_METADATA_ARTICLE_START = "UPDATE_METADATA_ARTICLE_START";
export const UPDATE_METADATA_ARTICLE_SUCCESS = "UPDATE_METADATA_ARTICLE_SUCCESS";
export const UPDATE_METADATA_ARTICLE_FAIL = "UPDATE_METADATA_ARTICLE_FAIL";
export const ADD_MEMBER_PROJECT_START = "ADD_MEMBER_PROJECT_START";
export const ADD_MEMBER_PROJECT_SUCCESS = "ADD_MEMBER_PROJECT_SUCCESS";
export const ADD_MEMBER_PROJECT_FAIL = "ADD_MEMBER_PROJECT_FAIL";
export const DELETE_MEMBER_PROJECT_START = "DELETE_MEMBER_PROJECT_START";
export const DELETE_MEMBER_PROJECT_SUCCESS = "DELETE_MEMBER_PROJECT_SUCCESS";
export const DELETE_MEMBER_PROJECT_FAIL = "DELETE_MEMBER_PROJECT_FAIL";
export const UPDATE_METADATA_ROOM_START = "UPDATE_METADATA_ROOM_START";
export const UPDATE_METADATA_ROOM_SUCCESS = "UPDATE_METADATA_ROOM_SUCCESS";
export const UPDATE_METADATA_ROOM_FAIL = "UPDATE_METADATA_ROOM_FAIL";
export const LOAD_METADATA_CONFIG_START = "LOAD_METADATA_CONFIG_START";
export const LOAD_METADATA_CONFIG_SUCCESS = "LOAD_METADATA_CONFIG_SUCCESS";
export const LOAD_METADATA_CONFIG_FAIL = "LOAD_METADATA_CONFIG_FAIL";
export const METADATA_LOADING = "METADATA_LOADING";
export const LOAD_SOAP_API_DEF_START = "LOAD_SOAP_API_DEF_START";
export const LOAD_SOAP_API_DEF_SUCCESS = "LOAD_SOAP_API_DEF_SUCCESS";
export const LOAD_SOAP_API_DEF_FAIL = "LOAD_SOAP_API_DEF_FAIL";
export const SAVE_METADATA_CONFIG_START = "SAVE_METADATA_CONFIG_START";
export const SAVE_METADATA_CONFIG_SUCCESS = "SAVE_METADATA_CONFIG_SUCCESS";
export const SAVE_METADATA_CONFIG_FAIL = "SAVE_METADATA_CONFIG_FAIL";
export const UPDATE_METADATA_CONFIG = "UPDATE_METADATA_CONFIG";
export const METADATA_CONDITIONAL_FAIL = "METADATA_CONDITIONAL_FAIL";
export const METADATA_CONDITIONAL_RESET = "METADATA_CONDITIONAL_RESET";

export const METADATA_INIT_CHANGE = "METADATA_INIT_CHANGE";
export const METADATA_CHANGE = "METADATA_CHANGE";
export const METADATA_RESET = "METADATA_RESET";

//Cart types
export const ADD_SELECTED_TO_CART = "ADD_SELECTED_TO_CART";
export const EMPTY_CART = "EMPTY_CART";
export const ADD_CLIP_TO_CART = "ADD_CLIP_TO_CART";
export const REMOVE_CLIP_FROM_CART = "REMOVE_CLIP_FROM_CART";
export const COPY_CART_START = "COPY_CART_START";
export const COPY_CART_SUCCESS = "COPY_CART_SUCCESS";
export const COPY_CART_FAIL = "COPY_CART_FAIL";
export const ADD_OBJ_TO_CART = "ADD_OBJ_TO_CART";
export const REMOVE_OBJ_FROM_CART = "REMOVE_OBJ_FROM_CART";
export const REMOVE_ALL_OBJ_FROM_CART = "REMOVE_ALL_OBJ_FROM_CART";

export const CART_DOWNLOAD_MF_START = "CART_DOWNLOAD_MF_START";
export const CART_DOWNLOAD_MF_SUCCESS = "CART_DOWNLOAD_MF_SUCCESS";
export const CART_DOWNLOAD_MF_FAIL = "CART_DOWNLOAD_MF_FAIL";

//mediafile types
export const DELETE_MEDIAFILE_START = "DELETE_MEDIAFILE_START";
export const DELETE_MEDIAFILE_SUCCESS = "DELETE_MEDIAFILE_SUCCESS";
export const DELETE_MEDIAFILE_FAIL = "DELETE_MEDIAFILE_FAIL";
export const EDIT_MEDIAFILE_START = "EDIT_MEDIAFILE_START";
export const EDIT_MEDIAFILE_FAIL = "EDIT_MEDIAFILE_FAIL";
export const EDIT_MEDIAFILE_SUCCESS = "EDIT_MEDIAFILE_SUCCESS";
export const MEDIAFILE_SET_THUMB_START = "MEDIAFILE_SET_THUMB_START";
export const MEDIAFILE_SET_THUMB_SUCCESS = "MEDIAFILE_SET_THUMB_SUCCESS";
export const MEDIAFILE_SET_THUMB_FAIL = "MEDIAFILE_SET_THUMB_FAIL";

//device types
export const DEVICE_LOAD_START = "DEVICE_LOAD_START";
export const DEVICE_LOAD_SUCCESS = "DEVICE_LOAD_SUCCESS";
export const DEVICE_LOAD_FAIL = "DEVICE_LOAD_FAIL";
export const DEVICE_SET_SEARCH = "DEVICE_SET_SEARCH";

//vimeo types
export const VIMEO_LOAD_START = "VIMEO_LOAD_START";
export const VIMEO_LOAD_SUCCESS = "VIMEO_LOAD_SUCCESS";
export const VIMEO_LOAD_FAIL = "VIMEO_LOAD_FAIL";
export const VIMEO_UPLOAD_START = "VIMEO_UPLOAD_START";
export const VIMEO_UPLOAD_SUCCESS = "VIMEO_UPLOAD_SUCCESS";
export const VIMEO_UPLOAD_FAIL = "VIMEO_UPLOAD_FAIL";
export const VIMEO_DELETE_START = "VIMEO_DELETE_START";
export const VIMEO_DELETE_SUCCESS = "VIMEO_DELETE_SUCCESS";
export const VIMEO_DELETE_FAIL = "VIMEO_DELETE_FAIL";
export const VIMEO_SET_CURRENT_VIDEO = "VIMEO_SET_CURRENT_VIDEO";
//export const DEVICE_SET_SEARCH = "DEVICE_SET_SEARCH";

//comment types
export const DELETE_COMMENT_START = "DELETE_COMMENT_START";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAIL = "DELETE_COMMENT_FAIL";
export const GET_COMMENTS_START = "GET_COMMENTS_START";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_FAIL = "GET_COMMENTS_FAIL";
export const ADD_COMMENT_START = "ADD_COMMENT_START";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAIL = "ADD_COMMENT_FAIL";
export const GET_CLIP_TIME_COMMENTS_SUCCESS = "GET_CLIP_TIME_COMMENTS_SUCCESS";
export const SET_CLIP_TIME_CURRENT_SUCCESS = "SET_CLIP_TIME_CURRENT_SUCCESS";
export const CHANGE_CLIP_TIME_CURRENT_SUCCESS = "CHANGE_CLIP_TIME_CURRENT_SUCCESS";
export const SET_TIME_COMMENT_TAB = "SET_TIME_COMMENT_TAB";

//admin types
export const ADMIN_GET_USERS_START = "ADMIN_GET_USERS_START";
export const ADMIN_GET_USERS_SUCCESS = "ADMIN_GET_USERS_SUCCESS";
export const ADMIN_GET_USERS_FAIL = "ADMIN_GET_USERS_FAIL";

export const ADMIN_SAVE_USER_START = "ADMIN_SAVE_USER_START";
export const ADMIN_SAVE_USER_SUCCESS = "ADMIN_SAVE_USER_SUCCESS";
export const ADMIN_SAVE_USER_FAIL = "ADMIN_SAVE_USER_FAIL";
export const ADMIN_SAVE_NEW_USER_START = "ADMIN_SAVE_NEW_USER_START";
export const ADMIN_SAVE_NEW_USER_SUCCESS = "ADMIN_SAVE_NEW_USER_SUCCESS";
export const ADMIN_SAVE_NEW_USER_FAIL = "ADMIN_SAVE_NEW_USER_FAIL";
export const ADMIN_SET_GRANTING = "ADMIN_SET_GRANTING";
export const ADMIN_GET_ALL_GRANTS_FAIL = "ADMIN_GET_ALL_GRANTS_FAIL";
export const ADMIN_GET_ALL_GRANTS_START = "ADMIN_GET_ALL_GRANTS_START";
export const ADMIN_SET_ALL_GRANTS = "ADMIN_SET_ALL_GRANTS";
export const ADMIN_DELETE_USER_START = "ADMIN_DELETE_USER_START";
export const ADMIN_DELETE_USER_SUCCESS = "ADMIN_DELETE_USER_SUCCESS";
export const ADMIN_DELETE_USER_FAIL = "ADMIN_DELETE_USER_FAIL";
export const ADMIN_SET_EDITUSER = "ADMIN_SET_EDITUSER";
export const ADMIN_LOAD_USER_SETTING_START = "ADMIN_LOAD_USER_SETTING_START";
export const ADMIN_LOAD_USER_SETTING_SUCCESS = "ADMIN_LOAD_USER_SETTING_SUCCESS";
export const ADMIN_LOAD_USER_SETTING_FAIL = "ADMIN_LOAD_USER_SETTING_FAIL";
export const ADMIN_SAVE_USER_SETTING_START = "ADMIN_SAVE_USER_SETTING_START";
export const ADMIN_SAVE_USER_SETTING_SUCCESS = "ADMIN_SAVE_USER_SETTING_SUCCESS";
export const ADMIN_SAVE_USER_SETTING_FAIL = "ADMIN_SAVE_USER_SETTING_FAIL";
export const ADMIN_LOAD_GROUP_SETTING_START = "ADMIN_LOAD_GROUP_SETTING_START";
export const ADMIN_LOAD_GROUP_SETTING_SUCCESS = "ADMIN_LOAD_GROUP_SETTING_SUCCESS";
export const ADMIN_LOAD_GROUP_SETTING_FAIL = "ADMIN_LOAD_GROUP_SETTING_FAIL";
export const ADMIN_SAVE_GROUP_SETTING_START = "ADMIN_SAVE_GROUP_SETTING_START";
export const ADMIN_SAVE_GROUP_SETTING_SUCCESS = "ADMIN_SAVE_GROUP_SETTING_SUCCESS";
export const ADMIN_SAVE_GROUP_SETTING_FAIL = "ADMIN_SAVE_GROUP_SETTING_FAIL";

//user types
export const USER_GET_USERS_START = "USER_GET_USERS_START";
export const USER_GET_USERS_SUCCESS = "USER_GET_USERS_SUCCESS";
export const USER_GET_USERS_FAIL = "USER_GET_USERS_FAIL";

// Notification types
export const NOTIFICATION_LOAD_START = "NOTIFICATION_LOAD_START";
export const NOTIFICATION_LOAD_SUCCESS = "NOTIFICATION_LOAD_SUCCESS";
export const NOTIFICATION_LOAD_FAIL = "NOTIFICATION_LOAD_FAIL";

export const NOTIFICATION_SEARCH_START = "NOTIFICATION_SEARCH_START";
export const NOTIFICATION_SEARCH_SUCCESS = "NOTIFICATION_SEARCH_SUCCESS";
export const NOTIFICATION_SEARCH_FAIL = "NOTIFICATION_SEARCH_FAIL";

export const NOTIFICATION_ADD_START = "NOTIFICATION_ADD_START";
export const NOTIFICATION_ADD_SUCCESS = "NOTIFICATION_ADD_SUCCESS";
export const NOTIFICATION_ADD_FAIL = "NOTIFICATION_ADD_FAIL";

export const NOTIFICATION_SET_START = "NOTIFICATION_SET_START";
export const NOTIFICATION_SET_SUCCESS = "NOTIFICATION_SET_SUCCESS";
export const NOTIFICATION_SET_FAIL = "NOTIFICATION_SET_FAIL";

// Notification approcval users
export const NOTIFICATION_APPROVAL_USER_START = "NOTIFICATION_APPROVAL_USER_START";
export const NOTIFICATION_APPROVAL_USER_SUCCESS = "NOTIFICATION_APPROVAL_USER_SUCCESS";
export const NOTIFICATION_APPROVAL_USER_FAIL = "NOTIFICATION_APPROVAL_USER_FAIL";

// Notification sender user
export const NOTIFICATION_SENDER_USER_START = "NOTIFICATION_SENDER_USER_START";
export const NOTIFICATION_SENDER_USER_SUCCESS = "NOTIFICATION_SENDER_USER_SUCCESS";
export const NOTIFICATION_SENDER_USER_FAIL = "NOTIFICATION_SENDER_USER_FAIL";

// workflows
export const WORKFLOW_SEND_START = "WORKFLOW_SEND_START";
export const WORKFLOW_SEND_SUCCESS = "WORKFLOW_SEND_SUCCESS";
export const WORKFLOW_SEND_FAIL = "WORKFLOW_SEND_FAIL";

// france.tv contacts
export const FTV_CONTACTS_SEARCH_START = "FTV_CONTACTS_SEARCH_START";
export const FTV_CONTACTS_SEARCH_SUCCESS = "FTV_CONTACTS_SEARCH_SUCCESS";
export const FTV_CONTACTS_SEARCH_FAIL = "FTV_CONTACTS_SEARCH_FAIL";
export const FTV_CONTACT_CREATE_START = "FTV_CONTACT_CREATE_START";
export const FTV_CONTACT_CREATE_SUCCESS = "FTV_CONTACT_CREATE_SUCCESS";
export const FTV_CONTACT_CREATE_FAIL = "FTV_CONTACT_CREATE_FAIL";
export const FTV_CONTACT_EDIT_START = "FTV_CONTACT_EDIT_START";
export const FTV_CONTACT_EDIT_SUCCESS = "FTV_CONTACT_EDIT_SUCCESS";
export const FTV_CONTACT_EDIT_FAIL = "FTV_CONTACT_EDIT_FAIL";
export const FTV_CLEAR_ERROR = "FTV_CLEAR_ERROR";
export const FTV_CONTACT_DELETE_START = "FTV_CONTACT_DELETE_START";
export const FTV_CONTACT_DELETE_SUCCESS = "FTV_CONTACT_DELETE_SUCCESS";
export const FTV_CONTACT_DELETE_FAIL = "FTV_CONTACT_DELETE_FAIL";
export const FTV_GROUPS_SEARCH_START = "FTV_GROUPS_SEARCH_START";
export const FTV_GROUPS_SEARCH_SUCCESS = "FTV_GROUPS_SEARCH_SUCCESS";
export const FTV_GROUPS_SEARCH_FAIL = "FTV_GROUPS_SEARCH_FAIL";
export const FTV_GROUP_CREATE_START = "FTV_GROUP_CREATE_START";
export const FTV_GROUP_CREATE_SUCCESS = "FTV_GROUP_CREATE_SUCCESS";
export const FTV_GROUP_CREATE_FAIL = "FTV_GROUP_CREATE_FAIL";
export const FTV_GROUP_DELETE_START = "FTV_GROUP_DELETE_START";
export const FTV_GROUP_DELETE_SUCCESS = "FTV_GROUP_DELETE_SUCCESS";
export const FTV_GROUP_DELETE_FAIL = "FTV_GROUP_DELETE_FAIL";
export const FTV_GROUP_GET_START = "FTV_GROUP_GET_START";
export const FTV_GROUP_GET_SUCCESS = "FTV_GROUP_GET_SUCCESS";
export const FTV_GROUP_GET_FAIL = "FTV_GROUP_GET_FAIL";
export const FTV_GROUP_SAVE_START = "FTV_GROUP_SAVE_START";
export const FTV_GROUP_SAVE_SUCCESS = "FTV_GROUP_SAVE_SUCCESS";
export const FTV_GROUP_SAVE_FAIL = "FTV_GROUP_SAVE_FAIL";
export const FTV_GROUP_REMOVE_START = "FTV_GROUP_REMOVE_START";
export const FTV_GROUP_REMOVE_SUCCESS = "FTV_GROUP_REMOVE_SUCCESS";
export const FTV_GROUP_REMOVE_FAIL = "FTV_GROUP_REMOVE_FAIL";
export const FTV_GROUP_ADD_START = "FTV_GROUP_ADD_START";
export const FTV_GROUP_ADD_SUCCESS = "FTV_GROUP_ADD_SUCCESS";
export const FTV_GROUP_ADD_FAIL = "FTV_GROUP_ADD_FAIL";
export const FTV_CONTACTS_SET_ROOM = "FTV_CONTACTS_SET_ROOM";
export const FTV_LOAD_CSV_USERS_START = "FTV_LOAD_CSV_USERS_START";
export const FTV_LOAD_CSV_USERS_SUCCESS = "FTV_LOAD_CSV_USERS_SUCCESS";
export const FTV_LOAD_CSV_USERS_FAIL = "FTV_LOAD_CSV_USERS_FAIL";
export const FTV_LOAD_CSV_FILES_START = "FTV_LOAD_CSV_FILES_START";
export const FTV_LOAD_CSV_FILES_SUCCESS = "FTV_LOAD_CSV_FILES_SUCCESS";
export const FTV_LOAD_CSV_FILES_FAIL = "FTV_LOAD_CSV_FILES_FAIL";

export const SDK_WORK_GET_START = "SDK_WORK_GET_START";
export const SDK_WORK_GET_SUCCESS = "SDK_WORK_GET_SUCCESS";
export const SDK_WORK_GET_ONE_SUCCESS = "SDK_WORK_GET_ONE_SUCCESS";
export const SDK_WORK_GET_FAIL = "SDK_WORK_GET_FAIL";
export const SDK_OBJECT_GET_START = "SDK_OBJECT_GET_START";
export const SDK_OBJECT_GET_SUCCESS = "SDK_OBJECT_GET_SUCCESS";
export const SDK_OBJECT_GET_FAIL = "SDK_OBJECT_GET_FAIL";
export const SDK_ITEM_GET_START = "SDK_ITEM_GET_START";
export const SDK_ITEM_GET_SUCCESS = "SDK_ITEM_GET_SUCCESS";
export const SDK_ITEM_GET_FAIL = "SDK_ITEM_GET_FAIL";
export const SDK_SEARCH_START = "SDK_SEARCH_START";
export const SDK_SEARCH_SUCCESS = "SDK_SEARCH_SUCCESS";
export const SDK_SET_OFFSET = "SDK_SET_OFFSET";
export const SDK_SET_LIMIT = "SDK_SET_LIMIT";
export const SDK_SET_SORT = "SDK_SET_SORT";
export const SDK_ON_SELECT = "SDK_ON_SELECT";
export const SET_SIDEBAR_FILTER = "SET_SIDEBAR_FILTER";

// statistics
export const STATISTICS_VISITS_SUCCESS = "STATISTICS_VISITS_SUCCESS";
export const STATISTICS_UNIQUE_VISITS_SUCCESS = "STATISTICS_UNIQUE_VISITS_SUCCESS";
export const STATISTICS_TOTAL_VIEWS_SUCCESS = "STATISTICS_TOTAL_VIEWS_SUCCESS";
export const STATISTICS_VIEWS_PER_DAY_SUCCESS = "STATISTICS_VIEWS_PER_DAY_SUCCESS";
export const STATISTICS_MOST_VIEWED_CLIPS_SUCCESS = "STATISTICS_MOST_VIEWED_CLIPS_SUCCESS";
export const STATISTICS_CSV_DOWNLOAD_SUCCESS = "STATISTICS_CSV_DOWNLOAD_SUCCESS";
export const STATISTICS_COUNT_CLIPS = "STATISTICS_COUNT_CLIPS";

// youtube
export const YOUTUBE_LOGIN_ADD_SUCCESS = "YOUTUBE_LOGIN_ADD_SUCCESS";
export const YOUTUBE_LOGIN_ADD_FAIL = "YOUTUBE_LOGIN_ADD_FAIL";
export const YOUTUBE_LOGIN_DELETE_SUCCESS = "YOUTUBE_LOGIN_DELETE_SUCCESS";
export const YOUTUBE_LOGIN_DELETE_FAIL = "YOUTUBE_LOGIN_DELETE_FAIL";
export const YOUTUBE_LOGIN_LIST_START = "YOUTUBE_LOGIN_LIST_START";
export const YOUTUBE_LOGIN_LIST_SUCCESS = "YOUTUBE_LOGIN_LIST_SUCCESS";
export const YOUTUBE_LOGIN_LIST_FAIL = "YOUTUBE_LOGIN_LIST_FAIL";
export const YOUTUBE_CHANNEL_LIST_START = "YOUTUBE_CHANNEL_LIST_START";
export const YOUTUBE_CHANNEL_LIST_SUCCESS = "YOUTUBE_CHANNEL_LIST_SUCCESS";
export const YOUTUBE_CHANNEL_LIST_FAIL = "YOUTUBE_CHANNEL_LIST_FAIL";
export const YOUTUBE_PLAYLIST_LIST_START = "YOUTUBE_PLAYLIST_LIST_START";
export const YOUTUBE_PLAYLIST_LIST_SUCCESS = "YOUTUBE_PLAYLIST_LIST_SUCCESS";
export const YOUTUBE_PLAYLIST_LIST_FAIL = "YOUTUBE_PLAYLIST_LIST_FAIL";
export const YOUTUBE_PLAYLIST_CREATE_START = "YOUTUBE_PLAYLIST_CREATE_START";
export const YOUTUBE_PLAYLIST_CREATE_SUCCESS = "YOUTUBE_PLAYLIST_CREATE_SUCCESS";
export const YOUTUBE_PLAYLIST_CREATE_FAIL = "YOUTUBE_PLAYLIST_CREATE_FAIL";
export const YOUTUBE_PLAYLIST_DELETE_START = "YOUTUBE_PLAYLIST_DELETE_START";
export const YOUTUBE_PLAYLIST_DELETE_SUCCESS = "YOUTUBE_PLAYLIST_DELETE_SUCCESS";
export const YOUTUBE_PLAYLIST_DELETE_FAIL = "YOUTUBE_PLAYLIST_DELETE_FAIL";
export const YOUTUBE_PLAYLIST_UPDATE_START = "YOUTUBE_PLAYLIST_UPDATE_START";
export const YOUTUBE_PLAYLIST_UPDATE_SUCCESS = "YOUTUBE_PLAYLIST_UPDATE_SUCCESS";
export const YOUTUBE_PLAYLIST_UPDATE_FAIL = "YOUTUBE_PLAYLIST_UPDATE_FAIL";
export const YOUTUBE_PLAYLIST_ITEMS_LIST_START = "YOUTUBE_PLAYLIST_ITEMS_LIST_START";
export const YOUTUBE_PLAYLIST_ITEMS_LIST_SUCCESS = "YOUTUBE_PLAYLIST_ITEMS_LIST_SUCCESS";
export const YOUTUBE_PLAYLIST_ITEMS_LIST_FAIL = "YOUTUBE_PLAYLIST_ITEMS_LIST_FAIL";
export const YOUTUBE_PLAYLIST_ITEMS_ADD_START = "YOUTUBE_PLAYLIST_ITEMS_ADD_START";
export const YOUTUBE_PLAYLIST_ITEMS_ADD_SUCCESS = "YOUTUBE_PLAYLIST_ITEMS_ADD_SUCCESS";
export const YOUTUBE_PLAYLIST_ITEMS_ADD_FAIL = "YOUTUBE_PLAYLIST_ITEMS_ADD_FAIL";
export const YOUTUBE_PLAYLIST_ITEMS_ORDER_START = "YOUTUBE_PLAYLIST_ITEMS_ORDER_START";
export const YOUTUBE_PLAYLIST_ITEMS_ORDER_SUCCESS = "YOUTUBE_PLAYLIST_ITEMS_ORDER_SUCCESS";
export const YOUTUBE_PLAYLIST_ITEMS_ORDER_FAIL = "YOUTUBE_PLAYLIST_ITEMS_ORDER_FAIL";
export const YOUTUBE_PLAYLIST_ITEMS_DELETE_START = "YOUTUBE_PLAYLIST_ITEMS_DELETE_START";
export const YOUTUBE_PLAYLIST_ITEMS_DELETE_SUCCESS = "YOUTUBE_PLAYLIST_ITEMS_DELETE_SUCCESS";
export const YOUTUBE_PLAYLIST_ITEMS_DELETE_FAIL = "YOUTUBE_PLAYLIST_ITEMS_DELETE_FAIL";
export const YOUTUBE_VIDEO_LIST_START = "YOUTUBE_VIDEO_LIST_START";
export const YOUTUBE_VIDEO_LIST_SUCCESS = "YOUTUBE_VIDEO_LIST_SUCCESS";
export const YOUTUBE_VIDEO_LIST_FAIL = "YOUTUBE_VIDEO_LIST_FAIL";
export const YOUTUBE_VIDEO_DELETE_START = "YOUTUBE_VIDEO_DELETE_START";
export const YOUTUBE_VIDEO_DELETE_SUCCESS = "YOUTUBE_VIDEO_DELETE_SUCCESS";
export const YOUTUBE_VIDEO_DELETE_FAIL = "YOUTUBE_VIDEO_DELETE_FAIL";
export const YOUTUBE_VIDEO_GET_START = "YOUTUBE_VIDEO_GET_START";
export const YOUTUBE_VIDEO_GET_SUCCESS = "YOUTUBE_VIDEO_GET_SUCCESS";
export const YOUTUBE_VIDEO_GET_FAIL = "YOUTUBE_VIDEO_GET_FAIL";
export const YOUTUBE_VIDEO_UPDATE_START = "YOUTUBE_VIDEO_UPDATE_START";
export const YOUTUBE_VIDEO_UPDATE_SUCCESS = "YOUTUBE_VIDEO_UPDATE_SUCCESS";
export const YOUTUBE_VIDEO_UPDATE_FAIL = "YOUTUBE_VIDEO_UPDATE_FAIL";
export const YOUTUBE_VIDEO_UPLOAD_START = "YOUTUBE_VIDEO_UPLOAD_START";
export const YOUTUBE_VIDEO_UPLOAD_SUCCESS = "YOUTUBE_VIDEO_UPLOAD_SUCCESS";
export const YOUTUBE_VIDEO_UPLOAD_FAIL = "YOUTUBE_VIDEO_UPLOAD_FAIL";

// crm
export const CRM_GET_USER_START = "CRM_GET_USER_START";
export const CRM_GET_USER_SUCCESS = "CRM_GET_USER_SUCCESS";
export const CRM_GET_USER_FAIL = "CRM_GET_USER_FAIL";
export const CRM_SEARCH_USERS_START = "CRM_SEARCH_USERS_START";
export const CRM_SEARCH_USERS_SUCCESS = "CRM_SEARCH_USERS_SUCCESS";
export const CRMUSERS_CSV_DOWNLOAD_SUCCESS = "CRMUSERS_CSV_DOWNLOAD_SUCCESS";
export const CRM_SEARCH_USERS_FAIL = "CRM_SEARCH_USERS_FAIL";
export const CRM_CREATE_USER_START = "CRM_CREATE_USER_START";
export const CRM_CREATE_USER_SUCCESS = "CRM_CREATE_USER_SUCCESS";
export const CRM_CREATE_USER_FAIL = "CRM_CREATE_USER_FAIL";
export const CRM_EDIT_USER_START = "CRM_EDIT_USER_START";
export const CRM_EDIT_USER_SUCCESS = "CRM_EDIT_USER_SUCCESS";
export const CRM_EDIT_USER_FAIL = "CRM_EDIT_USER_FAIL";
export const CRM_DELETE_USER_START = "CRM_DELETE_USER_START";
export const CRM_DELETE_USER_SUCCESS = "CRM_DELETE_USER_SUCCESS";
export const CRM_DELETE_USER_FAIL = "CRM_DELETE_USER_FAIL";

export const CRM_ALL_INST_SUCCESS = "CRM_ALL_INST_SUCCESS";
export const CRM_SEARCH_INST_START = "CRM_SEARCH_INST_START";
export const CRM_SEARCH_INST_SUCCESS = "CRM_SEARCH_INST_SUCCESS";
export const CRM_SEARCH_INST_FAIL = "CRM_SEARCH_INST_FAIL";
export const CRM_CREATE_INST_START = "CRM_CREATE_INST_START";
export const CRM_CREATE_INST_SUCCESS = "CRM_CREATE_INST_SUCCESS";
export const CRM_CREATE_INST_FAIL = "CRM_CREATE_INST_FAIL";
export const CRM_EDIT_INST_START = "CRM_EDIT_INST_START";
export const CRM_EDIT_INST_SUCCESS = "CRM_EDIT_INST_SUCCESS";
export const CRM_EDIT_INST_FAIL = "CRM_EDIT_INST_FAIL";
export const CRM_DELETE_INST_START = "CRM_DELETE_INST_START";
export const CRM_DELETE_INST_SUCCESS = "CRM_DELETE_INST_SUCCESS";
export const CRM_DELETE_INST_FAIL = "CRM_DELETE_INST_FAIL";

export const CRM_SEARCH_GROUP_START = "CRM_SEARCH_GROUP_START";
export const CRM_SEARCH_GROUP_SUCCESS = "CRM_SEARCH_GROUP_SUCCESS";
export const CRM_SEARCH_GROUP_FAIL = "CRM_SEARCH_GROUP_FAIL";
export const CRM_CREATE_GROUP_START = "CRM_CREATE_GROUP_START";
export const CRM_CREATE_GROUP_SUCCESS = "CRM_CREATE_GROUP_SUCCESS";
export const CRM_CREATE_GROUP_FAIL = "CRM_CREATE_GROUP_FAIL";
export const CRM_DELETE_GROUP_START = "CRM_DELETE_GROUP_START";
export const CRM_DELETE_GROUP_SUCCESS = "CRM_DELETE_GROUP_SUCCESS";
export const CRM_DELETE_GROUP_FAIL = "CRM_DELETE_GROUP_FAIL";
export const CRM_GET_GROUP_START = "CRM_GET_GROUP_START";
export const CRM_GET_GROUP_SUCCESS = "CRM_GET_GROUP_SUCCESS";
export const CRM_GET_GROUP_FAIL = "CRM_GET_GROUP_FAIL";
export const CRM_GET_GROUP_CSV_START = "CRM_GET_GROUP_CSV_START";
export const CRM_GET_GROUP_CSV_SUCCESS = "CRM_GET_GROUP_CSV_SUCCESS";
export const CRM_GET_GROUP_CSV_FAIL = "CRM_GET_GROUP_CSV_FAIL";
export const CRM_SAVE_GROUP_START = "CRM_SAVE_GROUP_START";
export const CRM_SAVE_GROUP_SUCCESS = "CRM_SAVE_GROUP_SUCCESS";
export const CRM_SAVE_GROUP_FAIL = "CRM_SAVE_GROUP_FAIL";
export const CRM_REMOVEFROM_GROUP_START = "CRM_REMOVEFROM_GROUP_START";
export const CRM_REMOVEFROM_GROUP_SUCCESS = "CRM_REMOVEFROM_GROUP_SUCCESS";
export const CRM_REMOVEFROM_GROUP_FAIL = "CRM_REMOVEFROM_GROUP_FAIL";
export const CRM_ADDTO_GROUP_START = "CRM_ADDTO_GROUP_START";
export const CRM_ADDTO_GROUP_SUCCESS = "CRM_ADDTO_GROUP_SUCCESS";
export const CRM_ADDTO_GROUP_FAIL = "CRM_ADDTO_GROUP_FAIL";

export const STATUSBAR_SET_MESSAGE = "STATUSBAR_SET_MESSAGE";
export const STATUSBAR_SET_MESSAGES = "STATUSBAR_SET_MESSAGES";
export const STATUSBAR_RESET_MESSAGE = "STATUSBAR_RESET_MESSAGE";
export const STATUSBAR_SET_EXCEPTION = "STATUSBAR_SET_EXCEPTION";
export const STATUSBAR_RESET_EXCEPTION = "STATUSBAR_RESET_EXCEPTION";

export const AI_TRANSCODING_START = "AI_TRANSCODING_START";
export const AI_TRANSCODING_UPDATE = "AI_TRANSCODING_UPDATE";
export const AI_TRANSCODING_SUCCESS = "AI_TRANSCODING_SUCCESS";
export const AI_TRANSCODING_FAIL = "AI_TRANSCODING_FAIL";

export const CDN_SYNC_START = "CDN_SYNC_START";
export const CDN_SYNC_SUCCESS = "CDN_SYNC_SUCCESS";
export const CDN_SYNC_FAIL = "CDN_SYNC_FAIL";
export const CDN_DELETE_START = "CDN_DELETE_START";
export const CDN_DELETE_SUCCESS = "CDN_DELETE_SUCCESS";
export const CDN_DELETE_FAIL = "CDN_DELETE_FAIL";

export const NLW_GET_STATS_SUCCESS = "NLW_GET_STATS_SUCCESS";

export const TAG_CATALOG_SEARCH_START = "TAG_CATALOG_SEARCH_START";
export const TAG_CATALOG_SEARCH_SUCCESS = "TAG_CATALOG_SEARCH_SUCCESS";
export const TAG_CATALOG_SEARCH_FAIL = "TAG_CATALOG_SEARCH_FAIL";
export const TAG_CATALOG_NEW_START = "TAG_CATALOG_NEW_START";
export const TAG_CATALOG_NEW_SUCCESS = "TAG_CATALOG_NEW_SUCCESS";
export const TAG_CATALOG_NEW_FAIL = "TAG_CATALOG_NEW_FAIL";
export const TAG_CATALOG_EDIT_START = "TAG_CATALOG_EDIT_START";
export const TAG_CATALOG_EDIT_SUCCESS = "TAG_CATALOG_EDIT_SUCCESS";
export const TAG_CATALOG_EDIT_FAIL = "TAG_CATALOG_EDIT_FAIL";
export const TAG_CATALOG_DELETE_START = "TAG_CATALOG_DELETE_START";
export const TAG_CATALOG_DELETE_SUCCESS = "TAG_CATALOG_DELETE_SUCCESS";
export const TAG_CATALOG_DELETE_FAIL = "TAG_CATALOG_DELETE_FAIL";
export const TAG_CATALOG_NEW_REL_START = "TAG_CATALOG_NEW_REL_START";
export const TAG_CATALOG_NEW_REL_SUCCESS = "TAG_CATALOG_NEW_REL_SUCCESS";
export const TAG_CATALOG_NEW_REL_FAIL = "TAG_CATALOG_NEW_REL_FAIL";
export const TAG_CATALOG_DELETE_REL_START = "TAG_CATALOG_DELETE_REL_START";
export const TAG_CATALOG_DELETE_REL_SUCCESS = "TAG_CATALOG_DELETE_REL_SUCCESS";
export const TAG_CATALOG_DELETE_REL_FAIL = "TAG_CATALOG_DELETE_REL_FAIL";
export const TAG_CATALOG_TAGS_REL_START = "TAG_CATALOG_TAGS_REL_START";
export const TAG_CATALOG_TAGS_REL_SUCCESS = "TAG_CATALOG_TAGS_REL_SUCCESS";
export const TAG_CATALOG_TAGS_REL_FAIL = "TAG_CATALOG_TAGS_REL_FAIL";

export const TAG_TREE_SEARCH_START = "TAG_TREE_SEARCH_START";
export const TAG_TREE_SEARCH_SUCCESS = "TAG_TREE_SEARCH_SUCCESS";
export const TAG_TREE_SEARCH_FAIL = "TAG_TREE_SEARCH_FAIL";
export const TAG_TREE_NEW_START = "TAG_TREE_NEW_START";
export const TAG_TREE_NEW_SUCCESS = "TAG_TREE_NEW_SUCCESS";
export const TAG_TREE_NEW_FAIL = "TAG_TREE_NEW_FAIL";
export const TAG_TREE_EDIT_START = "TAG_TREE_EDIT_START";
export const TAG_TREE_EDIT_SUCCESS = "TAG_TREE_EDIT_SUCCESS";
export const TAG_TREE_EDIT_FAIL = "TAG_TREE_EDIT_FAIL";
export const TAG_TREE_DELETE_START = "TAG_TREE_DELETE_START";
export const TAG_TREE_DELETE_SUCCESS = "TAG_TREE_DELETE_SUCCESS";
export const TAG_TREE_DELETE_FAIL = "TAG_TREE_DELETE_FAIL";

export const CDN_LOG_GET_START = "CDN_LOG_GET_START";
export const CDN_LOG_GET_SUCCESS = "CDN_LOG_GET_SUCCESS";
export const CDN_LOG_GET_FAIL = "CDN_LOG_GET_FAIL";
export const CDN_LOG_RESET = "CDN_LOG_RESET";

export const CLIP_REFERENCES_LOAD_START = "CLIP_REFERENCES_LOAD_START";
export const CLIP_REFERENCES_LOAD_SUCCESS = "CLIP_REFERENCES_LOAD_SUCCESS";
export const CLIP_REFERENCES_LOAD_FAIL = "CLIP_REFERENCES_LOAD_FAIL";

export const RELATED_CLIPS_GET_START = "RELATED_CLIPS_GET_START";
export const RELATED_CLIPS_GET_SUCCESS = "RELATED_CLIPS_GET_SUCCESS";
export const RELATED_CLIPS_GET_FAIL = "RELATED_CLIPS_GET_FAIL";
